<script>
    if (window.top !== window.self) {
        window.top.location = window.self.location;
    }
</script>
<router-outlet></router-outlet>
<idle-timeout></idle-timeout>

